<template>
  <div
    class="modal fade"
    id="approveRepeatedClient"
    tabindex="-1"
    role="dialog"
    aria-labelledby="approveRepeatedClientLabel"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            class="modal-title"
            id="approveRepeatedClientLabel"
          >
            Approve Repeated Client
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              class="col-md-12"
              v-if="isLoading"
            >
              <h3 class="text-center">
                Processing...
              </h3>
            </div>
            <div
              class="col-md-12"
              v-else
            >
              <div class="row">
                <div
                  class="col-md-12 margin-bottom"
                  v-if="message !== null"
                >
                  <div
                    class="alert alert-warning alert-dismissible"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    {{ message }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="borrow-wrapper">
                    <div
                      class="borrow-current"
                      v-if="current !== null"
                    >
                      <div class="borrow-card">
                        <div class="borrow-header bg-current">
                          <div
                            class="borrow-cover"
                            :style="`background-image: url(${current.borrower_photo !== null ? base_url+'/'+current.borrower_photo : '/img/avatar.png'})`"
                          />
                        </div>
                        <div class="borrow-body">
                          <h3>{{ current.name }} {{ current.last_name }}</h3>
                          <p>{{ current.gender }}</p>
                          <p>{{ current.phone }}</p>
                          <p>{{ current.email }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="sync">
                      <div class="sync-icon">
                        <i class="fa fa-refresh" />
                      </div>
                    </div>
                    <div
                      class="borrow-previous"
                      v-if="previous !== null"
                    >
                      <div class="borrow-card">
                        <div class="borrow-header bg-previous">
                          <div
                            class="borrow-cover"
                            :style="`background-image: url(${previous.borrower_photo !== null ? base_url + '/' + previous.borrower_photo : '/img/avatar.png'})`"
                          />
                        </div>
                        <div class="borrow-body">
                          <h3>{{ previous.name }} {{ previous.last_name }}</h3>
                          <p class="badge bg-info">
                            Client ID: {{ previous.client_id }}
                          </p>
                          <p>{{ current.gender }}</p>
                          <p>{{ previous.phone }}</p>
                          <p>{{ previous.email }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="approvedPreviousAndCurrentBorrowers"
          >
            Approved
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ApprovedRepeatedClientModal',
  data () {
    return {
      previous: null,
      current: null,
      isLoading: true,
      base_url: process.env.VUE_APP_API,
      message: null
    }
  },
  computed: {
    ...mapState({
      params: state => state.approvedRepeatedClient.data
    })
  },
  watch: {
    params () {
      this.message = null
      this.getPreviousAndCurrentBorrowers()
    }
  },
  methods: {
    getPreviousAndCurrentBorrowers () {
      this.isLoading = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/get-previous-and-current-borrowers', this.params)
        .then((response) => {
          if (response.data.data !== null) {
            this.previous = response.data.data.previous
            this.current = response.data.data.current
          } else {
            this.previous = null
            this.current = null
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    approvedPreviousAndCurrentBorrowers (e) {
      e.preventDefault()
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/approved-repeated-client', this.params)
        .then((response) => {
          if (response.data.code === 1) {
            this.$refs.close.click()
            this.$emit('refreshDatatable')
            this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
          } else {
            this.message = response.data.message
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped>
  .borrow-wrapper {
    display: grid;
    grid-template-columns: 1fr 100px 1fr;
    grid-template-rows: 1fr;
    grid-gap: 10px;
  }

  .borrow-card {
    height: auto;
    width: 100%;
    min-height: 380px;
    background: #ddd;
    border-radius: 6px;
  }

  .borrow-header {
    position: relative;
    height: 145px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .borrow-cover {
    position: absolute;
    bottom: -60px;
    width: 120px;
    height: 120px;
    background-size: cover;
    border-radius: 9999px;
  }

  .borrow-body {
    padding: 10px;
    margin-top: 40px;
    text-align: center;
  }

  .bg-previous {
    background: #00a65a;
  }

  .bg-current {
    background: #3c8dbc;
  }

  .sync {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sync-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border: 1px solid #00acd6;
    border-radius: 9999px;
  }

  .sync-icon i {
    font-size: 32px;
    color: #00c0ef;
  }
</style>
